<template>
	<v-row dense class="trained-face-source-picker">
		<v-col
			v-for="source in sources"
			:key="source.key"
			cols="12"
			md="4"
		>
			<v-btn
				block
				outlined
				:color="source.key === value ? 'primary' : undefined"
				:disabled="source.disabled"
				@click="$emit('input', source.key)"
			>
				<v-icon left small>{{ source.icon }}</v-icon>
				{{ source.text }}
			</v-btn>
			<div v-if="source.hint" class="caption grey--text text--darken-1 mt-1">
				{{ source.hint }}
			</div>
		</v-col>
	</v-row>
</template>

<script>
	export default {
		name: 'TrainedFaceSourcePicker',
		props: {
			value: {
				type: String,
				default: 'upload',
			},
			sources: {
				type: Array,
				default: () => [],
			},
		},
	}
</script>
